import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const OutlinerLeftMenuIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 16,
    width,
    height,
    color = 'currentColor',
    onClick,
    strokeWidth = 1.5,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <rect
        x="7"
        y="4.5"
        width="6.8"
        height="4"
        rx="1"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      <rect
        x="11"
        y="10.5"
        width="6.8"
        height="4"
        rx="1"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      <rect
        x="11"
        y="16.5"
        width="6.8"
        height="4"
        rx="1"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      <path
        d="M6.5 7.5v11M6.5 12h2.5M6.5 18h2.5"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

OutlinerLeftMenuIcon.displayName = 'OutlinerLeftMenuIcon';
